import { BaseModel } from '../../../../../../core/_base/crud';

export class KhuVucKhoSumary extends BaseModel{
    IdKho: number;
    RealHang: number;
    RealCot: number;
    RealTang: number;
    component: KhuVucKho[];
    dataConfigVTK: KhoVTKConfig[];

    clear(){
        this.IdKho = 0;
        this.component = [];
        this.dataConfigVTK = [];
    }
    copy(item: KhuVucKhoSumary){
        this.IdKho = item.IdKho;
        this.component = item.component;
        this.dataConfigVTK = item.dataConfigVTK;
    }
}

export class KhuVucKho extends BaseModel{

    static defaultColor: any = {
        CLEAR: 'white',
        ROAD: '#e8eaed',
        NOT_SAVE: '#0000004a',
        FULL: '#ff000038',
        NOT_FULL: '#f1c4ff'
    };

    IdKvk: number
    TenKhuVuc: string
    MoTa: string
    TuHang: number  // -1 nếu là hàng dọc đường đi, -2 nếu là hàng ngang đường đi
    TuCot: number
    DenHang: number
    DenCot: number
    MaMau: string
    Type: number
    IdKho: number
    SoTang: number
    MaKhuVuc: string
    isSelect: boolean
    viTriLuuHang: number
    currentSelectTang: number;

    clear(){
        this.IdKvk = 0;
        this.TenKhuVuc = '';
        this.MoTa = '';
        this.TuHang = 0;
        this.TuCot = 0;
        this.DenHang = 0;
        this.DenCot = 0;
        this.MaMau = KhuVucKho.defaultColor.CLEAR;
        this.Type = 0;
        this.IdKho = 0;
        this.SoTang = 0;
        this.MaKhuVuc = '';
        this.isSelect = false;
        this.viTriLuuHang = -1;
        this.currentSelectTang = 1;
    }

    copy(item: KhuVucKho){
        this.IdKvk = item.IdKvk;
        this.TenKhuVuc = item.TenKhuVuc;
        this.MoTa = item.MoTa;
        this.TuHang =item.TuHang;
        this.TuCot = item.TuCot;
        this.DenHang = item.DenHang;
        this.DenCot = item.DenCot;
        this.MaMau = item.MaMau;
        this.Type = item.Type;
        this.IdKho = item.IdKho;
        this.SoTang = item.SoTang;
        this.MaKhuVuc = item.MaKhuVuc;
        this.isSelect = item.isSelect;
        this.viTriLuuHang = item.viTriLuuHang;
        this.currentSelectTang = item.currentSelectTang;
    }
}

export class KhoTinhTrangKho extends BaseModel{
    IdKho: number
    MaSo: string
    TongSoHang: number
    HangChuaXacNhan: number
    isMax : boolean
    clear(){
        this.IdKho = 0;
        this.MaSo = '';
        this.TongSoHang = 0;
        this.HangChuaXacNhan = 0;
        this.isMax = false;
    }

    copy(item: KhoTinhTrangKho){
        this.IdKho = item.IdKho;
        this.MaSo = item.MaSo;
        this.TongSoHang = item.TongSoHang;
        this.HangChuaXacNhan = item.HangChuaXacNhan;
        this.isMax = item.isMax;
    }
}

export class KhoVTKConfig extends BaseModel {
    Id: number;
    IdKho: number;
    VTK: string;
    IdDMVTKConfig: number;
    NgayTao: string;
    NguoiTao: number;
    NgaySua: string;
    NguoiSua: number;
    KL: number;

    clear(){
        this.Id = 0;
        this.IdKho = 0;
        this.VTK = "";
        this.IdDMVTKConfig = 0;
        this.NgayTao = "";
        this.NguoiTao = 0;
        this.KL = 0;
    }

    copy(item: KhoVTKConfig){
        this.Id = item.Id;
        this.IdKho = item.IdKho;
        this.VTK = item.VTK;
        this.IdDMVTKConfig = item.IdDMVTKConfig;
        this.NgayTao = item.NgayTao;
        this.NguoiTao = item.NguoiTao;
        this.KL = item.KL;
    }
}